import {
  Button,
  Form,
  Input,
  InputNumber,
  Popconfirm,
  Select,
  Tooltip,
} from "antd";

import React, {
  useCallback,
  useContext,
  useEffect,
  useMemo,
  useRef,
  useState,
} from "react";
import {
  EditOutlined,
  DeleteOutlined,
  PlusOutlined,
  SaveOutlined,
  CloseOutlined,
} from "@ant-design/icons";
import { useDispatch, useSelector } from "react-redux";
import Utils from "utils";
import {
  addNewXuatKhoCT,
  getXuatKhoCTByManx,
  setXuatKhoCTList,
  updateXuatKhoCT,
  deleteXuatKhoCT,
  getTonXuatKho,
} from "store/slices/sale/xuatkhoSlice";

import { initXuatKhoCt } from "views/app-views/sale/managements/QuanLyKho/XuatKho";
import { isEmpty } from "lodash";
import { substr } from "stylis";
import MediTable from "components/Custom";
import { getDmdonvichuyendoiDto } from "store/slices/sale/danhmucSlice";

const EditableContext = React.createContext(null);
const EditableRow = ({ index, ...props }) => {
  const [form] = Form.useForm();
  return (
    <Form form={form} component={false}>
      <EditableContext.Provider value={form}>
        <tr {...props} />
      </EditableContext.Provider>
    </Form>
  );
};

const EditableCell = ({
  title,
  editable,
  children,
  dataIndex,
  record,
  handleSave,
  ...restProps
}) => {
  const [editing, setEditing] = useState(false);
  const inputRef = useRef(null);
  const form = useContext(EditableContext);

  useEffect(() => {
    if (editing) {
      inputRef.current.focus();
    }
  }, [editing]);

  const toggleEdit = () => {
    if (record["action"] !== "initial" && record["action"] !== "update") {
      return;
    }

    if (
      record["action"] !== "initial" &&
      (dataIndex === "tenhh" ||
        dataIndex === "maview" ||
        dataIndex === "tendonvitinh")
    ) {
      return;
    }

    if (dataIndex === "tenhh" || dataIndex === "maview") {
      restProps.dispatch(
        getTonXuatKho({
          manx: restProps.xuatKhoId,
          makk: restProps.makk,
          ngay: new Date(restProps.ngay),
          chinhanhid: restProps.chinhanhid,
        })
      );
    }

    setEditing(!editing);
    form.setFieldsValue({
      [dataIndex]: record[dataIndex],
    });
  };
  const onChangeTenhh = (value) => {
    if (value === null) return;
    const data = restProps.tonXuatKhoList.find((i) => i.thuTu === value);

    restProps.setMahhdachon(data.mahh);
    form.setFieldValue([dataIndex], data.tenhh);
    handleSave(
      {
        ...record,
        mahh: data.mahh,
        maview: data.maview,
        mathamchieu: data.mathamchieu,
        tenhh: data.tenhh,
        quycachdonggoi: data.quycachdonggoi,
        tendonvitinh: data.tendonvitinh,
        losx: data.losx,
        handungtext: data.handungtext,
        dongia: data.dongia,
        dongiachuyendoi: data.dongia,
      },
      dataIndex
    );
  };
  const onChangeMaview = (value) => {
    if (value === null) return;
    const data = restProps.tonXuatKhoList.find((i) => i.thuTu === value);

    restProps.setMahhdachon(data.mahh);
    form.setFieldValue([dataIndex], data.maview);
    handleSave(
      {
        ...record,
        mahh: data.mahh,
        maview: data.maview,
        mathamchieu: data.mathamchieu,
        tenhh: data.tenhh,
        quycachdonggoi: data.quycachdonggoi,
        tendonvitinh: data.tendonvitinh,
        losx: data.losx,
        handungtext: data.handungtext,
        dongia: data.dongia,
        dongiachuyendoi: data.dongia,
      },
      dataIndex
    );
  };
  const onChangeSoLuong = (value) => {
    if (value === null) return;
    handleSave(
      {
        ...record,
        thanhtien: record.dongiachuyendoi * value,
      },
      dataIndex
    );
  };

  const onChangeTk = (value, obj) => {
    if (value === null) return;
    if (obj === "tknoid")
      handleSave(
        {
          ...record,
          tknoid: value,
        },
        dataIndex
      );
    else
      handleSave(
        {
          ...record,
          tkcoid: value,
        },
        dataIndex
      );
  };
  const onChangeDVT = (value) => {
    if (value === null) return;
    const data = restProps.DmdonvichuyendoiDtoList.find(
      (i) => i.machuyendoi === value
    );

    let _dongia =
      record.dongia /
      (data.pheptinh === "*" ? 1 / data.tylechuyen : data.tylechuyen);

    form.setFieldValue([dataIndex], data.tendonvitinh);
    handleSave(
      {
        ...record,
        machuyendoi: value,
        tendonvitinh: data.tendonvitinh,
        dongiachuyendoi: _dongia,
        thanhtien: _dongia * record.soluong,
      },
      dataIndex
    );
  };
  const save = async () => {
    try {
      const values = await form.validateFields();
      toggleEdit();
      handleSave({ ...record, ...values }, dataIndex);
    } catch (errInfo) {}
  };

  let childNode = children;

  if (editable) {
    childNode = editing ? (
      <Form.Item
        style={{
          margin: 0,
        }}
        name={dataIndex}
      >
        {dataIndex === "soluong" ? (
          <InputNumber
            style={{ width: "100%" }}
            step={1}
            formatter={(value) => Utils.formatterNumber(value)}
            parser={(value) => parserNumber(value)}
            ref={inputRef}
            onPressEnter={save}
            onBlur={save}
            onChange={(value) => onChangeSoLuong(value)}
          />
        ) : dataIndex === "tenhh" ? (
          <Select
            style={{ width: "100%" }}
            placeholder="Chọn thuốc vật tư"
            showSearch
            optionFilterProp="children"
            filterOption={(input, option) =>
              (option?.label ?? "").toLowerCase().includes(input.toLowerCase())
            }
            filterSort={(optionA, optionB) =>
              (optionA?.label ?? "")
                .toLowerCase()
                .localeCompare((optionB?.label ?? "").toLowerCase())
            }
            ref={inputRef}
            onPressEnter={save}
            onBlur={save}
            onChange={(value) => onChangeTenhh(value)}
            dropdownStyle={{
              maxHeight: 300,
              overflow: "auto",
              minWidth: 900,
            }}
          >
            {restProps.tonXuatKhoList.map((x) => (
              <Select.Option label={x.tenhh} value={x.thuTu} key={x.thuTu}>
                <div style={{ display: "flex" }}>
                  <table style={{ borderCollapse: "collapse", width: "850px" }}>
                    <tr style={{ border: "1px solid #dddddd", width: "850px" }}>
                      <th
                        style={{
                          minWidth: "100px",
                          border: "1px solid #dddddd",
                        }}
                      >
                        Mã nội bộ
                      </th>
                      <th
                        style={{
                          minWidth: "180px",
                          border: "1px solid #dddddd",
                        }}
                      >
                        Tên thuốc vật tư
                      </th>
                      <th
                        style={{
                          minWidth: "80px",
                          border: "1px solid #dddddd",
                        }}
                      >
                        Quy cách
                      </th>
                      <th
                        style={{
                          minWidth: "60px",
                          border: "1px solid #dddddd",
                        }}
                      >
                        ĐVT
                      </th>
                      <th
                        style={{
                          minWidth: "80px",
                          border: "1px solid #dddddd",
                        }}
                      >
                        Đơn giá
                      </th>
                      <th
                        style={{
                          minWidth: "80px",
                          border: "1px solid #dddddd",
                        }}
                      >
                        Tồn kho
                      </th>
                      <th
                        style={{
                          minWidth: "100px",
                          border: "1px solid #dddddd",
                        }}
                      >
                        Lô SX
                      </th>
                      <th
                        style={{
                          minWidth: "100px",
                          border: "1px solid #dddddd",
                        }}
                      >
                        HSD
                      </th>
                    </tr>
                    <tr style={{ border: "1px solid #dddddd", width: "850px" }}>
                      <td
                        style={{
                          width: "100px",
                          border: "1px solid #dddddd",
                        }}
                      >
                        <Tooltip title={x.mathamchieu}>
                          {substr(x.mathamchieu, 0, 12) +
                            (x.mathamchieu.length > 12 ? "..." : "")}
                        </Tooltip>
                      </td>
                      <td
                        style={{
                          width: "180px",
                          border: "1px solid #dddddd",
                        }}
                      >
                        <Tooltip title={x.tenhh}>
                          {substr(x.tenhh, 0, 40) +
                            (x.tenhh.length > 40 ? "..." : "")}
                        </Tooltip>
                      </td>
                      <td
                        style={{
                          width: "80px",
                          border: "1px solid #dddddd",
                          textAlign: "center",
                        }}
                      >
                        <Tooltip title={x.quycachdonggoi}>
                          {x.quycachdonggoi}
                        </Tooltip>
                      </td>
                      <td
                        style={{
                          width: "60px",
                          border: "1px solid #dddddd",
                        }}
                      >
                        {x.tendonvitinh}
                      </td>
                      <td
                        style={{
                          width: "80px",
                          border: "1px solid #dddddd",
                          textAlign: "right",
                        }}
                      >
                        {Utils.formatterNumber(x.dongia)}
                      </td>
                      <td
                        style={{
                          width: "80px",
                          border: "1px solid #dddddd",
                          textAlign: "right",
                          color: "red",
                        }}
                      >
                        {Utils.formatterNumber(x.tonkho)}
                      </td>
                      <td
                        style={{
                          width: "100px",
                          border: "1px solid #dddddd",
                        }}
                      >
                        {x.losx}
                      </td>
                      <td
                        style={{
                          width: "100px",
                          border: "1px solid #dddddd",
                          textAlign: "center",
                        }}
                      >
                        {x.handungtext}
                      </td>
                    </tr>
                  </table>
                </div>
              </Select.Option>
            ))}
          </Select>
        ) : dataIndex === "mathamchieu" ? (
          <Select
            style={{ width: "100%" }}
            placeholder="Chọn thuốc vật tư"
            showSearch
            optionFilterProp="children"
            filterOption={(input, option) =>
              (option?.label ?? "").toLowerCase().includes(input.toLowerCase())
            }
            filterSort={(optionA, optionB) =>
              (optionA?.label ?? "")
                .toLowerCase()
                .localeCompare((optionB?.label ?? "").toLowerCase())
            }
            ref={inputRef}
            onPressEnter={save}
            onBlur={save}
            onChange={(value) => onChangeMaview(value)}
            dropdownStyle={{
              maxHeight: 300,
              overflow: "auto",
              minWidth: 900,
            }}
          >
            {restProps.tonXuatKhoList.map((x) => (
              <Select.Option
                label={x.mathamchieu}
                value={x.thuTu}
                key={x.thuTu}
              >
                <div style={{ display: "flex" }}>
                  <table style={{ borderCollapse: "collapse", width: "850px" }}>
                    <tr style={{ border: "1px solid #dddddd", width: "850px" }}>
                      <th
                        style={{
                          minWidth: "100px",
                          border: "1px solid #dddddd",
                        }}
                      >
                        Mã nội bộ
                      </th>
                      <th
                        style={{
                          minWidth: "180px",
                          border: "1px solid #dddddd",
                        }}
                      >
                        Tên thuốc vật tư
                      </th>
                      <th
                        style={{
                          minWidth: "80px",
                          border: "1px solid #dddddd",
                        }}
                      >
                        Quy cách
                      </th>
                      <th
                        style={{
                          minWidth: "60px",
                          border: "1px solid #dddddd",
                        }}
                      >
                        ĐVT
                      </th>
                      <th
                        style={{
                          minWidth: "80px",
                          border: "1px solid #dddddd",
                        }}
                      >
                        Đơn giá
                      </th>
                      <th
                        style={{
                          minWidth: "80px",
                          border: "1px solid #dddddd",
                        }}
                      >
                        Tồn kho
                      </th>
                      <th
                        style={{
                          minWidth: "100px",
                          border: "1px solid #dddddd",
                        }}
                      >
                        Lô SX
                      </th>
                      <th
                        style={{
                          minWidth: "100px",
                          border: "1px solid #dddddd",
                        }}
                      >
                        HSD
                      </th>
                    </tr>
                    <tr style={{ border: "1px solid #dddddd", width: "850px" }}>
                      <td
                        style={{
                          width: "100px",
                          border: "1px solid #dddddd",
                        }}
                      >
                        <Tooltip title={x.mathamchieu}>
                          {substr(x.mathamchieu, 0, 12) +
                            (x.mathamchieu.length > 12 ? "..." : "")}
                        </Tooltip>
                      </td>
                      <td
                        style={{
                          width: "180px",
                          border: "1px solid #dddddd",
                        }}
                      >
                        <Tooltip title={x.tenhh}>
                          {substr(x.tenhh, 0, 40) +
                            (x.tenhh.length > 40 ? "..." : "")}
                        </Tooltip>
                      </td>
                      <td
                        style={{
                          width: "80px",
                          border: "1px solid #dddddd",
                        }}
                      >
                        <Tooltip title={x.quycachdonggoi}>
                          {x.quycachdonggoi}
                        </Tooltip>
                      </td>
                      <td
                        style={{
                          width: "60px",
                          border: "1px solid #dddddd",
                        }}
                      >
                        {x.tendonvitinh}
                      </td>
                      <td
                        style={{
                          width: "80px",
                          border: "1px solid #dddddd",
                          textAlign: "right",
                        }}
                      >
                        {Utils.formatterNumber(x.dongia)}
                      </td>
                      <td
                        style={{
                          width: "80px",
                          border: "1px solid #dddddd",
                          textAlign: "right",
                          color: "red",
                        }}
                      >
                        {Utils.formatterNumber(x.tonkho)}
                      </td>
                      <td
                        style={{
                          width: "100px",
                          border: "1px solid #dddddd",
                        }}
                      >
                        {x.losx}
                      </td>
                      <td
                        style={{
                          width: "100px",
                          border: "1px solid #dddddd",
                          textAlign: "center",
                        }}
                      >
                        {x.handungtext}
                      </td>
                    </tr>
                  </table>
                </div>
              </Select.Option>
            ))}
          </Select>
        ) : dataIndex === "tknoid" || dataIndex === "tkcoid" ? (
          <Select
            style={{ width: "100%" }}
            placeholder="Chọn tài khoản"
            showSearch
            onChange={(c) => onChangeTk(c, dataIndex)}
            optionFilterProp="children"
            onPressEnter={save}
            onBlur={save}
            filterOption={(input, option) =>
              (option?.label ?? "").toLowerCase().includes(input.toLowerCase())
            }
            filterSort={(optionA, optionB) =>
              (optionA?.label ?? "")
                .toLowerCase()
                .localeCompare((optionB?.label ?? "").toLowerCase())
            }
            ref={inputRef}
            options={restProps.dinhKhoanCate.map((m) => ({
              value: m.id,
              label: `${m.soTaiKhoan} - ${m.tenTaiKhoan}`,
            }))}
          />
        ) : dataIndex === "tendonvitinh" ? (
          <Select
            style={{ width: "100%" }}
            placeholder="Chọn đơn vị tính"
            showSearch
            optionFilterProp="children"
            filterOption={(input, option) =>
              (option?.label ?? "").toLowerCase().includes(input.toLowerCase())
            }
            filterSort={(optionA, optionB) =>
              (optionA?.label ?? "")
                .toLowerCase()
                .localeCompare((optionB?.label ?? "").toLowerCase())
            }
            ref={inputRef}
            onPressEnter={save}
            onBlur={save}
            onChange={(value) => onChangeDVT(value)}
            dropdownStyle={{
              maxHeight: 300,
              overflow: "auto",
              minWidth: 500,
            }}
          >
            {restProps.DmdonvichuyendoiDtoList.map((x) => (
              <Select.Option
                label={x.tendonvitinh}
                value={x.machuyendoi}
                key={x.machuyendoi}
              >
                <div style={{ display: "flex" }}>
                  <table style={{ borderCollapse: "collapse", width: "250px" }}>
                    <tr style={{ border: "1px solid #dddddd", width: "250px" }}>
                      <th
                        style={{
                          width: "70px",
                          border: "1px solid #dddddd",
                        }}
                      >
                        ĐVT
                      </th>
                      <th
                        style={{
                          width: "180px",
                          border: "1px solid #dddddd",
                        }}
                      >
                        Mô tả
                      </th>
                    </tr>
                    <tr style={{ border: "1px solid #dddddd", width: "250px" }}>
                      <td
                        style={{
                          width: "70px",
                          border: "1px solid #dddddd",
                        }}
                      >
                        <Tooltip title={x.tendonvitinh}>
                          {x.tendonvitinh}
                        </Tooltip>
                      </td>
                      <td
                        style={{
                          width: "180px",
                          border: "1px solid #dddddd",
                        }}
                      >
                        <Tooltip title={x.mota}>{x.mota}</Tooltip>
                      </td>
                    </tr>
                  </table>
                </div>
              </Select.Option>
            ))}
          </Select>
        ) : (
          <Input ref={inputRef} onPressEnter={save} onBlur={save} />
        )}
      </Form.Item>
    ) : (
      <div
        className="editable-cell-value-wrap"
        style={{
          paddingRight: 10,
          height: 20,
          width: "100%",
        }}
        onClick={toggleEdit}
      >
        {children}
      </div>
    );
  }

  return <td {...restProps}>{childNode}</td>;
};

export const parserNumber = (val) => {
  if (!val) return 0;
  return Number.parseFloat(
    // eslint-disable-next-line no-useless-escape
    val.replace(/\$\s?|(\.*)/g, "").replace(/(\,{1})/g, ".")
  ).toFixed(5);
};
export default function TableXuatKhoCTList({
  xuatKhoCTList,
  dmThuocVatTuList,
  xuatKhoId,
  maKkxuat,
  ngayxuat,
  chinhanhid,
}) {
  const dispatch = useDispatch();
  const { dinhKhoanCate } = useSelector((state) => state.dinhKhoanCategory);
  const { tonXuatKhoList } = useSelector((state) => state.xuatKhoSale);

  const [mahhdachon, setMahhdachon] = useState(null);
  const { DmdonvichuyendoiDtoList } = useSelector((state) => state.danhMucSale);

  useEffect(() => {
    if (mahhdachon === null || mahhdachon === 0) return;
    dispatch(getDmdonvichuyendoiDto(mahhdachon));
  }, [dispatch, mahhdachon]);

  const onClickCancelAction = useCallback(
    (record, index) => {
      const newData = xuatKhoCTList.slice(0);
      const indexX = newData.findIndex((item) => record.thuTu === item.thuTu);
      newData[indexX] = { ...newData[indexX], action: "" };
      dispatch(setXuatKhoCTList(newData));
    },
    [dispatch, xuatKhoCTList]
  );
  const onClickAction = useCallback(
    (record, index) => {
      const newData = xuatKhoCTList.slice(0);

      const payload = {
        mahh: record.mahh,
        tenhh: record.tenhh,
        maview: record.maview,
        losx: record.losx,
        handungtext: record.handungtext,
        dongia: record.dongia,
        thanhtien: record.thanhtien,
        soluong: record.soluong,
        manx: xuatKhoId,
        tknoid: record.tknoid,
        tkcoid: record.tkcoid,
        machuyendoi: record.machuyendoi,
        onSuccess: () => {
          dispatch(
            getXuatKhoCTByManx({
              manx: xuatKhoId,
              isNewCt: record.action === "initial",
            })
          );
        },
      };

      if (isEmpty(payload.tenhh)) {
        return;
      }
      if (record.action === initXuatKhoCt.action) {
        dispatch(addNewXuatKhoCT(payload));
      } else {
        if (record.thuTu !== null && record.action !== "update") {
          const indexX = newData.findIndex(
            (item) => record.thuTu === item.thuTu
          );
          newData[indexX] = { ...newData[indexX], action: "update" };
          dispatch(setXuatKhoCTList(newData));
        } else {
          dispatch(updateXuatKhoCT(payload));
        }
      }
    },
    [dispatch, xuatKhoCTList, xuatKhoId]
  );
  const tableColumns = useMemo(
    () => [
      {
        title: "STT",
        width: 40,
        align: "center",
        dataIndex: "thuTu",
      },
      {
        title: "Mã nội bộ",
        width: 100,
        dataIndex: "mathamchieu",
        editable: true,
        render: (txt, record) => (
          <Tooltip title={record.mathamchieu}>
            <div>
              {!isEmpty(record.mathamchieu) ? (
                record.mathamchieu.substr(0, 15) +
                (record.mathamchieu?.length > 15 ? "..." : "")
              ) : (
                <i
                  style={{
                    fontSize: "16px",
                    color: "blue",
                    paddingLeft: "20px",
                  }}
                >
                  ...
                </i>
              )}
            </div>
          </Tooltip>
        ),
      },
      {
        title: "Tên thuốc, vật tư",
        width: 180,
        dataIndex: "tenhh",
        editable: true,
        render: (txt, record) => (
          <Tooltip title={record.tenhh}>
            <div>
              {!isEmpty(record.tenhh) ? (
                record.tenhh.substr(0, 45) +
                (record.tenhh?.length > 45 ? "..." : "")
              ) : (
                <i
                  style={{
                    fontSize: "16px",
                    color: "blue",
                    paddingLeft: "10px",
                  }}
                >
                  Chọn hàng hóa...
                </i>
              )}
            </div>
          </Tooltip>
        ),
      },
      {
        title: "Quy cách",
        dataIndex: "quycachdonggoi",
        width: 100,
        editable: true,
        render: (txt, record) => (
          <Tooltip title={record.quycachdonggoi}>
            {record.quycachdonggoi}
          </Tooltip>
        ),
      },
      {
        title: "ĐVT",
        dataIndex: "tendonvitinh",
        width: 100,
        editable: true,
        render: (txt, record) => (
          <Tooltip title={record.tendonvitinh}>{record.tendonvitinh}</Tooltip>
        ),
      },
      {
        title: "Lô SX",
        width: 80,
        dataIndex: "losx",
      },
      {
        title: "HSD",
        width: 80,
        dataIndex: "handungtext",
        align: "center",
      },
      {
        title: "Tk nợ",
        width: 120,
        dataIndex: "tknoid",
        editable: true,
        render: (e, r, i) => dinhKhoanCate?.find((f) => f.id === e)?.tenView,
      },
      {
        title: "Tk có",
        width: 120,
        dataIndex: "tkcoid",
        editable: true,
        render: (e, r, i) => dinhKhoanCate?.find((f) => f.id === e)?.tenView,
      },
      {
        title: "Số lượng",
        width: 80,
        dataIndex: "soluong",
        align: "right",
        editable: true,
        isMoney: true,
        render: (value) => (value ? Utils.formatterNumber(value) : 0),
      },
      {
        title: "Đơn giá",
        width: 80,
        dataIndex: "dongiachuyendoi",
        align: "right",
        render: (value) => (value ? Utils.formatterNumber(value) : 0),
      },
      {
        title: "Thành tiền",
        width: 90,
        dataIndex: "thanhtien",
        align: "right",
        render: (value) => (value ? Utils.formatterNumber(value) : 0),
      },
      // {
      //   title: "Tiền thuế",
      //   width: 90,
      //   dataIndex: "thanhtienthue",
      //   align: "right",
      //   render: (value) => (value ? Utils.formatterNumber(value) : 0),
      // },
      {
        fixed: "right",
        width: 120,
        align: "center",
        dataIndex: "action",
        render: (_, record, index) => (
          <>
            {record.action === "initial" ? (
              <Button
                disabled={
                  !record.tenhh || xuatKhoId === null || xuatKhoId === 0
                }
                title={"Thêm chi tiết"}
                onClick={() => onClickAction(record, index)}
                className="mr-2"
                icon={<PlusOutlined />}
                shape="circle"
              />
            ) : record.action === "update" ? (
              <>
                <Button
                  title="Lưu chi tiết"
                  disabled={
                    xuatKhoCTList.filter((x) => x.action === "update").length >
                      0 &&
                    record.manxct !==
                      xuatKhoCTList.filter((x) => x.action === "update")[0]
                        ?.manxct
                  }
                  onClick={() => onClickAction(record, index)}
                  className="mr-2"
                  icon={<SaveOutlined />}
                  shape="circle"
                />
                <Button
                  title="Hủy"
                  disabled={
                    xuatKhoCTList.filter((x) => x.action === "update").length >
                      0 &&
                    record.manxct !==
                      xuatKhoCTList.filter((x) => x.action === "update")[0]
                        ?.manxct
                  }
                  onClick={() => onClickCancelAction(record, index)}
                  className="mr-2"
                  icon={<CloseOutlined />}
                  shape="circle"
                />
              </>
            ) : (
              <>
                <Button
                  title="Sửa chi tiết"
                  disabled={
                    xuatKhoCTList.filter((x) => x.action === "update").length >
                      0 &&
                    record.thuTu !==
                      xuatKhoCTList.filter((x) => x.action === "update")[0]
                        ?.thuTu
                  }
                  onClick={() => onClickAction(record, index)}
                  className="mr-2"
                  icon={<EditOutlined />}
                  shape="circle"
                />
                <Popconfirm
                  title="Bạn có muốn xóa chi tiết?"
                  placement="topLeft"
                  onConfirm={() => {
                    const payload = {
                      mahh: record.mahh,
                      tenhh: record.tenhh,
                      maview: record.maview,
                      losx: record.losx,
                      handungtext: record.handungtext,
                      dongia: record.dongia,
                      thanhtien: record.thanhtien,
                      soluong: record.soluong,
                      manx: xuatKhoId,
                      onSuccess: () => {
                        dispatch(
                          getXuatKhoCTByManx({
                            manx: xuatKhoId,
                            isNewCt: false,
                          })
                        );
                      },
                    };
                    dispatch(deleteXuatKhoCT(payload));
                  }}
                >
                  <Button
                    title={"Xóa chi tiết"}
                    disabled={
                      xuatKhoCTList.filter((x) => x.action === "update")
                        .length > 0 &&
                      record.thuTu !==
                        xuatKhoCTList.filter((x) => x.action === "update")[0]
                          ?.thuTu
                    }
                    className="mr-2"
                    icon={<DeleteOutlined type="primary" />}
                    shape="circle"
                  />
                </Popconfirm>
              </>
            )}
          </>
        ),
      },
    ],
    [
      dinhKhoanCate,
      dispatch,
      onClickAction,
      onClickCancelAction,
      xuatKhoCTList,
      xuatKhoId,
    ]
  );

  const handleSave = (row) => {
    const newData = xuatKhoCTList.slice(0);
    const index = newData.findIndex((item) => row.thuTu === item.thuTu);
    const item = newData[index];
    newData.splice(index, 1, { ...item, ...row });
    dispatch(setXuatKhoCTList(newData));
  };

  const columns = tableColumns.map((col) => {
    if (!col.editable) {
      return col;
    }
    return {
      ...col,
      onCell: (record) => ({
        record,
        editable: col.editable,
        dataIndex: col.dataIndex,
        title: col.title,
        handleSave: handleSave,
        isDate: col.isDate,
        isMoney: col.isMoney,
        dmThuocVatTuList: dmThuocVatTuList,
        xuatKhoCTList: xuatKhoCTList,
        dispatch: dispatch,
        xuatKhoId: xuatKhoId,
        ngay: ngayxuat,
        makk: maKkxuat,
        tonXuatKhoList: tonXuatKhoList,
        dinhKhoanCate: dinhKhoanCate,
        setMahhdachon: setMahhdachon,
        DmdonvichuyendoiDtoList: DmdonvichuyendoiDtoList,
        chinhanhid: chinhanhid,
      }),
    };
  });

  const components = {
    body: {
      row: EditableRow,
      cell: EditableCell,
    },
  };
  return (
    <MediTable
      components={components}
      tableColumns={columns}
      dataSource={xuatKhoCTList}
      scroll={{ x: "max-content", y: "400px" }}
      // components={components}
      // columns={columns}
      // dataSource={xuatKhoCTList}
      // rowKey={(_, index) => index}
      // bordered
      // style={{ padding: "0px" }}
      // fixed={true}
      // pagination={false}
      // scroll={{ x: 950, y: "calc(100vh - 520px)" }}
      onRenderFooter={(xuatKhoCTList) => (
        <div>
          <div>
            Số khoản:
            <b style={{ color: "green", paddingLeft: "5px" }}>
              {Utils.formatterNumber(
                xuatKhoCTList.filter((x) => x.thuTu).length
              )}
            </b>
          </div>
          <div>
            Tổng tiền:
            <b style={{ color: "red", paddingLeft: "5px" }}>
              {Utils.formatterNumber(
                xuatKhoCTList
                  .filter((x) => x.thuTu)
                  .reduce((prev, current) => prev + current?.thanhtien || 0, 0)
              )}
            </b>
          </div>
          {/* <div>
            Tổng tiền thuế:
            <b style={{ color: "red", paddingLeft: "5px" }}>
              {Utils.formatterNumber(
                xuatKhoCTList
                  .filter((x) => x.thuTu)
                  .reduce(
                    (prev, current) => prev + current?.thanhtienthue || 0,
                    0
                  )
              )}
            </b>
          </div> */}
        </div>
      )}
    />
  );
}
